export const DOCUMENT_CATEGORY_CODES = {
  IDENTITY: 'IDENTITY',
  EDUCATION: 'EDUCATION',
  PROFILE: 'PROFILE',
  OTHERS: 'OTHERS',
} as const;

export type DocumentCategoryCode = (typeof DOCUMENT_CATEGORY_CODES)[keyof typeof DOCUMENT_CATEGORY_CODES];

/** Document type codes - must match qhrms.DocumentTypes.Code in the database. */
export const DOCUMENT_TYPE_CODES = {
  PROFILE_PHOTO: 'PROFILE',
  OTHERS: 'OTRS',
} as const;

export type DocumentTypeCode = (typeof DOCUMENT_TYPE_CODES)[keyof typeof DOCUMENT_TYPE_CODES];

export const DOCUMENT_UPLOAD = {
  MAX_SIZE_MB: 10,
  ALLOWED_FORMATS: ['PDF', 'JPG', 'PNG', 'Word'] as const,
  IMAGE_FORMATS: ['JPG', 'PNG'] as const,
  CUSTOM_NAME_MAX_LENGTH: 100,
  ACCEPT_MAP: {
    PDF: '.pdf,application/pdf',
    JPG: '.jpg,.jpeg,image/jpeg',
    PNG: '.png,image/png',
    Word: '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  } as const,
} as const;

export const DOCUMENT_ACCEPT_ALL = Object.values(DOCUMENT_UPLOAD.ACCEPT_MAP).join(',');

export const DOCUMENT_ACCEPT_IMAGES = [
  DOCUMENT_UPLOAD.ACCEPT_MAP.JPG,
  DOCUMENT_UPLOAD.ACCEPT_MAP.PNG,
].join(',');
